// IndividualCompetenceTableSummary.jsx
import React from "react";
import { Table } from "antd";
import './individualCompetenceTable.css';

const formatNumber = (val, digits = 1) => {
    const n = Number(val);
    return Number.isFinite(n) ? n.toFixed(digits) : "-";
};

const IndividualCompetenceTableSummary = ({ competence = {}, redLight = 60, yellowLight = 80 }) => {
    const { subdimensions = [] } = competence;

    const getColor = (value) => {
        if (!Number.isFinite(value)) return "transparent";
        if (value <= redLight) return "#e53935";
        if (value <= yellowLight) return "#fbc02d";
        return "#43a047";
    };

    const getContrastTextColor = (bgColor) =>
        String(bgColor).toLowerCase() === '#fbc02d' ? '#000' : '#fff';

    const columns = [
        {
            title: <span style={{ fontSize: "10px" }}>PREGUNTA</span>,
            dataIndex: "questionNumber",
            key: "questionNumber",
            width: 80,
            render: (val) => <span style={{ fontSize: "10px" }}>{val}</span>,
        },
        {
            title: <span style={{ fontSize: "10px" }}>Texto</span>,
            dataIndex: "questionText",
            key: "questionText",
            render: (val) => <span style={{ fontSize: "10px" }}>{val}</span>,
        },
        {
            title: <span style={{ fontSize: "10px" }}>PROM.</span>,
            dataIndex: "average",
            key: "average",
            align: "center",
            render: (val) => (
                (() => {
                    const bgColor = getColor(val);
                    const textColor = getContrastTextColor(bgColor);
                    return (
                <div
                    style={{
                        backgroundColor: bgColor,
                        color: textColor,
                        fontSize: "10px",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        display: "inline-block",
                        minWidth: "35px",
                    }}
                >
                    {formatNumber(val, 1)}
                </div>
                    );
                })()
            ),
        },
    ];

    const data = subdimensions.map((sub, idx) => ({
        key: `summary-${idx}`,
        questionNumber: `Pregunta ${idx + 1}`,
        questionText: sub.question ?? sub.title ?? sub.ean_question ?? "",
        average: Number(sub.average),
        another: Number(sub.another),
    }));

    return (
        <Table
            className="table-individual-competence"
            columns={columns}
            dataSource={data}
            bordered
            pagination={false}
            size="small"
            style={{ marginBottom: 20 }}
        />
    );
};

export default IndividualCompetenceTableSummary;
